import { today } from '@components/ArtBoard/Export/helpers'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useSelector } from 'react-redux'

import { DEFAULT_PAGE_NAME } from '@/constants/defaultNames'
import type { ExportBlockItem, ExportData } from '@/hooks/exportDropdown/types'
import { useGetDataForExport } from './useGetDataForExport'

export const useTXTExport: any = () => {
  const projectId = useSelector(migrationProjectSelector.getProjectId)
  const projectName = useSelector(migrationProjectSelector.getProjectTitle)

  const { getExportData } = useGetDataForExport()

  const handleClickTXTExport = () => {
    const sitemapText = getExportData().flatMap(
      (section: ExportData[], index: number) => generateTree(section, index)
    )

    const doc = [
      `This Text Sitemap is created with https://octopus.do on ${today()}`,
      `Visual Sitemap — https://octopus.do/${projectId}`,
      '',
      '',
      projectName,
      '',
      ...sitemapText,
    ]

    return Promise.resolve(
      new Blob([doc.join('\n')], { type: 'text/plain;charset=utf-8' })
    )
  }

  const generateTree = (
    nodes: ExportData[],
    sectionIndex: number,
    parentPrefix = ''
  ): string[] => {
    const result: string[] = []

    nodes.forEach((node, index) => {
      const prefix = parentPrefix
        ? `${parentPrefix}.${index + 1}`
        : `${sectionIndex + 1}`

      result.push(`${prefix} ${node.title || DEFAULT_PAGE_NAME}`)

      if (node.blocks.length) {
        result.push('')
        node.blocks.forEach((block: ExportBlockItem) => {
          result.push(`  ${block.title}`)
        })
      }

      const childrenText = generateTree(node.children, sectionIndex, prefix)

      if (childrenText.length) {
        result.push('')
        result.push(...childrenText)
      }

      result.push('')
    })

    return result
  }

  return {
    handleClickTXTExport,
  }
}
